import { _config as chengxueluConfig } from "./partner/chengxuelu.com/config";
import { _config as spracheundwissenConfig } from "./partner/spracheundwissen.com/config";
import { _config as clubedealemaoConfig } from "./partner/clubedealemao.com/config";
import { _config as punkifyConfig } from "./partner/punkify.com/config";
import { _config as englishbisaConfig } from "./partner/englishbisa.com/config";
import { _config as lingoprofConfig } from "./partner/lingoprof.com/config";
import { _config as frenchamiConfig } from "./partner/frenchami.com/config";
import { _config as gliConfig } from "./partner/gli.demo/config";
import { _config as elingwistaConfig } from "./partner/elingwista.com/config";
import { _config as berlitzConfig } from "./partner/berlitz.com/config";
import { _config as saySoConfig } from "./partner/say-so.pl/config";
import { _config as iliEduskyConfig } from "./partner/ili-edusky.pl/config";
import { _config as inicijativaConfig } from "./partner/inicijativa.biz/config";
import { _config as magyarIskolaConfig } from "./partner/magyar-iskola.hu/config";
import { _config as emAcademyConfig } from "./partner/emacademy.eu/config";
import { _config as leventenglishConfig } from "./partner/leventenglish.com/config";
import { _config as teachersTeamConfig } from "./partner/pogad.ai/config";
import { _config as talkioLocalConfig } from "./partner/talkio.local/config";
import { _config as defaultConfig } from "./default/config";
import { _config as talkioKoreaConfig } from "./partner/ko.talkio.ai/config";
import { _config as spanishLanguageCenterMiamiConfig } from "./partner/spanish-languagecenter.com/config";
import { SiteConfig } from "./types";
import { _config as speakifyrConfig } from "./partner/speakifyr.com/config";
import { _config as iblsprogConfig } from "./partner/iblsprog.dk/config";
import { _config as berlitzTechConfig } from "./partner/berlitz.tech/config";
import { _config as g_one_business_englishConfig } from "./partner/g-one-business-english.com/config";
import { _config as larkbcConfig } from "./partner/larkbc.pl/config";
import { _config as talkioKoreaBetaConfig } from "./partner/ko-beta.talkio.ai/config";
import { _config as questfeConfig } from "./partner/questfe.pl/config";
import { _config as multilangoConfig } from "./partner/multilango.com/config";
import { _config as lexiConfig } from "./partner/lexi.eklektika.pl/config";
import { _config as talkioConfig } from "./partner/ko.talkio.ai/config";
import { _config as yanairConfig } from "./partner/yanair.org/config";
import { _config as speakenoConfig } from "./partner/speakeno.com/config";

export const partnerConfigs = {
  localhost: talkioLocalConfig,
  "talkio.local": talkioLocalConfig,
  "chengxuelu.com": chengxueluConfig,
  "spracheundwissen.com": spracheundwissenConfig,
  "clubedealemao.com": clubedealemaoConfig,
  "punkify.com": punkifyConfig,
  "englishbisa.com": englishbisaConfig,
  "lingoprof.com": lingoprofConfig,
  "frenchami.com": frenchamiConfig,
  "talkio.education": gliConfig,
  "elingwista.com": elingwistaConfig,
  "say-so.pl": saySoConfig,
  "ili.ai.edusky.pl": iliEduskyConfig,
  "berlitz-platforms.io": berlitzConfig,
  "inicijativa.biz": inicijativaConfig,
  "magyar-iskola.hu": magyarIskolaConfig,
  "emacademy.eu": emAcademyConfig,
  "leventenglish.com": leventenglishConfig,
  "ko.talkio.ai": talkioKoreaConfig,
  "pogad.ai": teachersTeamConfig,
  "spanish-languagecenter.com": spanishLanguageCenterMiamiConfig,
  "speakifyr.com": speakifyrConfig,
  "iblsprog.dk": iblsprogConfig,
  "berlitz.tech": berlitzTechConfig,
  "g-one-business-english.com": g_one_business_englishConfig,
  "larkbc.pl": larkbcConfig,
  "ko-beta.talkio.ai": talkioKoreaBetaConfig,
  "questfe.pl": questfeConfig,
  "multilango.com": multilangoConfig,
  "lexi.eklektika.pl": lexiConfig,
  "talkio.ai": talkioConfig,
  "yanair.org": yanairConfig,
  "speakeno.com": speakenoConfig,
};

export type PartnerConfigId = keyof typeof partnerConfigs;

const partnerDomain = process.env.NEXT_PUBLIC_PARTNER_DOMAIN as
  | keyof typeof partnerConfigs
  | undefined;

export const siteConfig: SiteConfig = partnerDomain
  ? {
      ...defaultConfig,
      ...partnerConfigs[partnerDomain],
    }
  : defaultConfig;

if (process.env.NEXT_PUBLIC_IS_PARTNER === "true" && !siteConfig) {
  throw new Error(`Partner domain ${partnerDomain} is not configured in allConfigs`);
}
